
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';

import PasswordField from '../../../fields/PasswordField.vue';
import { postUserPasswordChange } from '../../../client/password';

@Component({
    components: { PasswordField, ValidationObserver },
})
export default class ChangeUserPassword extends Vue {
    @Prop(String) public readonly id!: string;

    local = {
        oldPassword: '',
        password: '',
        password2: '',
    };

    async submit() {
        if (this.local.password == this.local.password2) {
            await this.changePassword();
        } else {
            this.$buefy.toast.open({
                message: this.$t('message.passwordsDoNotMatch').toString(),
                type: 'is-warning',
                position: 'is-top',
            });
        }
    }

    async changePassword() {
        if (await postUserPasswordChange(this.local.oldPassword!!, this.id, this.local.password!!)) {
            this.$buefy.toast.open({
                message: this.$t('message.passwordChanged').toString(),
                type: 'is-success',
                position: 'is-top',
            });
            this.local.oldPassword = '';
            this.local.password = '';
            this.local.password2 = '';
            this.$router.go(-1);
        } else {
            this.$buefy.toast.open({
                message: this.$t('message.passwordChangeFailed').toString(),
                type: 'is-warning',
                position: 'is-top',
            });
        }
    }
}
